import React from "react";
// import { useTranslation } from "react-i18next";

const FooterInfo = () => {
  // const { t } = useTranslation();

  return (
    <div className="bg-white shadow rounded-lg p-6 mt-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="flex justify-center md:justify-end">
          <img
            src="./logo.jpg"
            alt="logo"
            className="h-20 w-20 rounded-full border"
          />
        </div>
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="text-green-900 font-bold text-2xl mb-2">
            COPD健康宣導網站
          </div>
          {/* <div className="text-gray-600 text-sm mb-1 flex items-center">
            <span className="material-icons mr-1">email</span>
            info@copd-edu.org
          </div>
          <div className="text-gray-600 text-sm mb-1 flex items-center">
            <span className="material-icons mr-1">phone</span>
            02-1234-5678
          </div>
          <div className="text-gray-600 text-sm flex items-center">
            <span className="material-icons mr-1">location_on</span>
            台北市某某區某某路1號
          </div> */}
        </div>
      </div>
      <hr className="my-6 border-gray-200" />
      <div className="text-gray-400 text-sm text-center">
        © {new Date().getFullYear()} COPD健康宣導網站
      </div>
    </div>
  );
};

export default FooterInfo;
